import { render } from "./Book.vue?vue&type=template&id=1f950d4b&ts=true"
import script from "./Book.vue?vue&type=script&lang=ts"
export * from "./Book.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build_4ed9b393/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__